export default __webpack_public_path__ + "static/alkdash-new-2f8819755fafb54528641673fa0340e0.png";